import { getFirestore } from '../config';

export default function useFirestore() {
  return getFirestore;
}
